"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("core-js/modules/es6.array.find-index");
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.number.constructor");
var _member = require("@/api/member/member");
var _ModifyingUserLevel = _interopRequireDefault(require("./ModifyingUserLevel.vue"));
var _labelManagement = require("@/api/member/labelManagement");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'MemberList',
  components: {
    ModifyingUserLevel: _ModifyingUserLevel.default
  },
  data: function data() {
    return {
      loading: false,
      // loading
      pagination: {
        // currentPage: 1, // 默认第几页
        total: 0 // 条数
      },
      activeName: 'second',
      queryData: {
        queryType: 1,
        // 查询类型[1:用户管理，2：黑名单用户，3：风险用户]
        memberListParam: {
          memberId: '',
          // 会员id
          phone: '',
          // 手机号
          userNo: '',
          // userNo
          idCardNumber: '',
          // 证件号
          nickname: '',
          // 用户昵称
          spreadCodeSystem: '',
          // 系统邀请码
          spreadCodeDefined: '',
          // 自定义邀请码
          startRegisterTime: '',
          // 开始注册时间
          endRegisterTime: '',
          // 结束注册时间
          lastLoginTime: '',
          // 用户最近使用时间
          effective: '',
          // 是否有效用户
          status: '',
          // 用户状态
          grade: '',
          // 自购等级
          promotionGrade: '',
          // 推广等级
          lastActiveDays: '',
          // 最近活跃天数
          lastTakeDays: '',
          // 最近消费天数
          // promotionAmount: '', // 推广金
          teamIncomeStart: null,
          // selfAmount: '', // 自购金
          selfIncomeStart: null,
          tbRelationId: '',
          // 淘宝id
          pddRelationId: '',
          // 拼多多id
          // 订单
          startTime: '',
          //	开始时间
          endTime: '',
          // 结束时间
          minOrderCount: '',
          // 最小订单数
          maxOrderCount: '',
          // 最大订单数
          platform: '' // 平台类型
        },
        labelParam: {
          labelId: null // 标签id
        },
        page: {
          page: 1,
          size: 10
        }
      },
      options: [],
      props: {
        multiple: true
      },
      tableData: [],
      checkList: ['头像', '用户昵称', '会员标签', '手机号码', '用户编码', '用户ID', '有效用户', '用户状态', '状态变更时间', '累计推广金', '累计自购金', '用户最近使用时间', '直邀粉丝数', '用户等级', '直属上级', '操作'],
      disabled: false,
      // 禁用
      disabled1: false,
      // 禁用最大最小订单数
      disabled2: false,
      // 禁用标签
      labelOptions: [],
      labelLoaded: false // 新增：标记是否已加载完标签
    };
  },
  watch: {
    queryData: {
      handler: function handler(newValue, oldValue) {
        if (!this.disabled1) {
          if (Number(newValue.memberListParam.minOrderCount.length) > 0 || Number(newValue.memberListParam.maxOrderCount) > 0) {
            this.disabled = true;
            this.disabled2 = true;
          }
          if (Number(newValue.memberListParam.minOrderCount.length) === 0 && Number(newValue.memberListParam.maxOrderCount) === 0) {
            this.disabled = false;
            this.disabled2 = false;
          }
        }
      },
      deep: true
    }
  },
  created: function created() {
    var Selected_Column = localStorage.getItem('Selected_Column');
    if (Selected_Column) {
      this.checkList = JSON.parse(Selected_Column);
    }
    this.memberQueryMemberGradeApi();
    if (sessionStorage.getItem('userDetails_Query_parameter')) {
      this.queryData = JSON.parse(sessionStorage.getItem('userDetails_Query_parameter'));
    }
    console.log('-------------------', this.$route.params.labelId);
    if (this.$route.params.labelId) {
      this.queryData = {
        queryType: 1,
        // 查询类型[1:用户管理，2：黑名单用户，3：风险用户]
        memberListParam: {
          memberId: '',
          // 会员id
          phone: '',
          // 手机号
          userNo: '',
          // userNo
          idCardNumber: '',
          // 证件号
          nickname: '',
          // 用户昵称
          spreadCodeSystem: '',
          // 系统邀请码
          spreadCodeDefined: '',
          // 自定义邀请码
          startRegisterTime: '',
          // 开始注册时间
          endRegisterTime: '',
          // 结束注册时间
          lastLoginTime: '',
          // 用户最近使用时间
          effective: '',
          // 是否有效用户
          status: '',
          // 用户状态
          grade: '',
          // 自购等级
          promotionGrade: '',
          // 推广等级
          lastActiveDays: '',
          // 最近活跃天数
          lastTakeDays: '',
          // 最近消费天数
          // promotionAmount: '', // 推广金
          teamIncomeStart: null,
          // selfAmount: '', // 自购金
          selfIncomeStart: null,
          tbRelationId: '',
          // 淘宝id
          pddRelationId: '',
          // 拼多多id
          // 订单
          startTime: '',
          //	开始时间
          endTime: '',
          // 结束时间
          minOrderCount: '',
          // 最小订单数
          maxOrderCount: '',
          // 最大订单数
          platform: '' // 平台类型
        },
        labelParam: {
          labelId: this.$route.params.labelId // 标签id
        },
        page: {
          page: 1,
          size: 10
        }
      };
    }
    this.memberQueryMemberListApi();
    this.memberLabels();
  },
  methods: {
    onLabel: function onLabel(val) {
      if (val) {
        this.disabled = true;
        this.disabled1 = true;
        this.queryData.memberListParam = {
          memberId: '',
          // 会员id
          phone: '',
          // 手机号
          nickname: '',
          // 用户昵称
          spreadCodeSystem: '',
          // 系统邀请码
          spreadCodeDefined: '',
          // 自定义邀请码
          startRegisterTime: '',
          // 开始注册时间
          endRegisterTime: '',
          // 结束注册时间
          lastLoginTime: '',
          // 用户最近使用时间
          effective: '',
          // 是否有效用户
          status: '',
          // 用户状态
          grade: '',
          // 自购等级
          promotionGrade: '',
          // 推广等级
          lastActiveDays: '',
          // 最近活跃天数
          lastTakeDays: '',
          // 最近消费天数
          // promotionAmount: '', // 推广金
          teamIncomeStart: null,
          // selfAmount: '', // 自购金
          selfIncomeStart: null,
          tbRelationId: '',
          // 淘宝id
          pddRelationId: '',
          // 拼多多id
          idCardNumber: '',
          // 证件号
          // 订单
          startTime: '',
          //	开始时间
          endTime: '',
          // 结束时间
          minOrderCount: '',
          // 最小订单数
          maxOrderCount: '',
          // 最大订单数
          platform: '' // 平台类型
        };
      } else {
        this.disabled = false;
        this.disabled1 = false;
      }
    },
    memberLabels: function () {
      var _memberLabels2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var params, res;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              params = {};
              _context.n = 1;
              return (0, _labelManagement.memberLabels)(params);
            case 1:
              res = _context.v;
              if (res.code === 0) {
                this.labelOptions = res.data.allLabels || [];
              }
              // 标记加载完成（无论成功或失败都置为 true，避免一直展示加载态）
              this.labelLoaded = true;
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function memberLabels() {
        return _memberLabels2.apply(this, arguments);
      }
      return memberLabels;
    }(),
    // 存储列
    onCheckBox: function onCheckBox() {
      localStorage.setItem('Selected_Column', JSON.stringify(this.checkList));
    },
    // 用户详情
    onUserDetails: function onUserDetails(value) {
      this.$router.push({
        path: 'userDetails',
        query: {
          memberId: value.memberId,
          nickname: value.nickname
        }
      });
    },
    onUserDetails1: function onUserDetails1(id, name) {
      this.$router.push({
        path: 'userDetails',
        query: {
          memberId: id,
          nickname: name
        }
      });
    },
    // 查询
    onInquire: function onInquire() {
      // 查询参数存储
      sessionStorage.setItem('userDetails_Query_parameter', JSON.stringify(this.queryData));
      this.queryData.page.page = 1;
      this.queryData.page.size = 10;
      this.memberQueryMemberListApi();
    },
    // 重置
    onInitialize: function onInitialize() {
      this.disabled = false;
      this.disabled1 = false;
      this.disabled2 = false;
      this.queryData = {
        queryType: 1,
        // 查询类型[1:用户管理，2：黑名单用户，3：风险用户]
        memberListParam: {
          memberId: '',
          // 会员id
          phone: '',
          // 手机号
          nickname: '',
          // 用户昵称
          spreadCodeSystem: '',
          // 系统邀请码
          spreadCodeDefined: '',
          // 自定义邀请码
          startRegisterTime: '',
          // 开始注册时间
          endRegisterTime: '',
          // 结束注册时间
          lastLoginTime: '',
          // 用户最近使用时间
          effective: '',
          // 是否有效用户
          status: '',
          // 用户状态
          grade: '',
          // 自购等级
          promotionGrade: '',
          // 推广等级
          lastActiveDays: '',
          // 最近活跃天数
          lastTakeDays: '',
          // 最近消费天数
          // promotionAmount: '', // 推广金
          // selfAmount: '', // 自购金
          teamIncomeStart: null,
          selfIncomeStart: null,
          tbRelationId: '',
          // 淘宝id
          pddRelationId: '',
          // 拼多多id
          idCardNumber: '',
          // 证件号
          // 订单
          startTime: '',
          //	开始时间
          endTime: '',
          // 结束时间
          minOrderCount: '',
          // 最小订单数
          maxOrderCount: '',
          // 最大订单数
          platform: '' // 平台类型
        },
        labelParam: {
          labelId: null // 标签id
        },
        page: {
          page: 1,
          size: 10
        }
      };
      this.deleteArrayItem('订单量');
      this.memberQueryMemberListApi();
      // 查询参数存储
      sessionStorage.setItem('userDetails_Query_parameter', JSON.stringify(this.queryData));
    },
    handleSizeChange: function handleSizeChange(val) {
      this.queryData.page.size = val;
      this.memberQueryMemberListApi();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.queryData.page.page = val;
      this.memberQueryMemberListApi();
    },
    deleteArrayItem: function deleteArrayItem(val) {
      var index = this.checkList.findIndex(function (item) {
        return item === val;
      });
      if (index !== -1) {
        this.checkList.splice(index, 1);
      }
    },
    memberQueryMemberListApi: function () {
      var _memberQueryMemberListApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        var params, res, _t;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              if (this.queryData.memberListParam.minOrderCount || this.queryData.memberListParam.maxOrderCount) {
                this.checkList.push('订单量');
                this.queryData.memberListParam = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.queryData.memberListParam), {
                  memberId: '',
                  // 会员id
                  phone: '',
                  // 手机号
                  nickname: '',
                  // 用户昵称
                  spreadCodeSystem: '',
                  // 系统邀请码
                  spreadCodeDefined: '',
                  // 自定义邀请码
                  startRegisterTime: '',
                  // 开始注册时间
                  endRegisterTime: '',
                  // 结束注册时间
                  lastLoginTime: '',
                  // 用户最近使用时间
                  effective: '',
                  // 是否有效用户
                  status: '',
                  // 用户状态
                  grade: '',
                  // 自购等级
                  promotionGrade: '',
                  // 推广等级
                  lastActiveDays: '',
                  // 最近活跃天数
                  lastTakeDays: '',
                  // 最近消费天数
                  promotionAmount: '',
                  // 推广金
                  selfAmount: '',
                  // 自购金
                  tbRelationId: '',
                  // 淘宝id
                  pddRelationId: '',
                  // 拼多多id
                  idCardNumber: '' // 证件号
                });
              } else {
                this.deleteArrayItem('订单量');
              }
              params = (0, _objectSpread2.default)({}, this.queryData);
              this.loading = true;
              _context2.n = 1;
              return (0, _member.memberQueryMemberListApi)(params);
            case 1:
              res = _context2.v;
              this.loading = false;
              if (res.code === 0) {
                this.tableData = res.data.data;
                this.pagination.total = res.data.total;
              }
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t = _context2.v;
              this.loading = false;
              console.log(_t);
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function memberQueryMemberListApi() {
        return _memberQueryMemberListApi2.apply(this, arguments);
      }
      return memberQueryMemberListApi;
    }(),
    memberQueryMemberGradeApi: function () {
      var _memberQueryMemberGradeApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3() {
        var res, _t2;
        return (0, _regenerator2.default)().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              _context3.n = 1;
              return (0, _member.memberQueryMemberGradeApi)();
            case 1:
              res = _context3.v;
              this.options = res.data;
              _context3.n = 3;
              break;
            case 2:
              _context3.p = 2;
              _t2 = _context3.v;
              console.log(_t2);
            case 3:
              return _context3.a(2);
          }
        }, _callee3, this, [[0, 2]]);
      }));
      function memberQueryMemberGradeApi() {
        return _memberQueryMemberGradeApi2.apply(this, arguments);
      }
      return memberQueryMemberGradeApi;
    }(),
    // onDow() {
    //   window.location.href = 'https://zf-pub-dev.oss-cn-hangzhou.aliyuncs.com/excel/%E7%94%A8%E6%88%B7%E7%AD%89%E7%BA%A7%E4%BF%AE%E6%94%B9%E6%A8%A1%E6%9D%BF.xlsx'
    // },
    onBatchModification: function onBatchModification() {
      this.$refs.userLevel.open();
    },
    refresh: function refresh() {
      this.memberQueryMemberListApi();
    }
  }
};